import axios from "axios";
import { sentryAPICatch } from "../sentryAPICatch";

const putData = async (url, data, canceltoken) => {
  try {
    var bodyFormData = new FormData();
    bodyFormData.set("data", JSON.stringify(data));
    const options = {
      method: "PUT",
      data: bodyFormData,
      url: url.charAt(0) === '/' ? "/api" + url : "/api/" + url,
      cancelToken: canceltoken ? canceltoken : null,
    };
    return (
      await axios(options).catch((err) => {
        if (axios.isCancel(err)) {
          return;
        } else {
          if (err.response.status === 401) {
            let from = window.location.pathname + window.location.search;
            from = from.replaceAll("/logout/expired?from=", "");
            if (from === "/") {
              window.location.href = "/logout/expired";
            } else {
              window.location.href = "/logout/expired?from=" + from;
            }
          } else if (err.request) {
            sentryAPICatch(err, url);
            console.error("Request: ", err);
          } else {
            sentryAPICatch(err, url);
            console.error("Other: ", err);
          }
        }
        return;
      })
    ).data;
  } catch (err) {
    return null;
  }
};
export default putData;
